module.exports = __webpack_public_path__ + "img/borrow-crypto.504e4981.svg";